<template>
  <b-container>
    <h4>Student Attendance By District</h4>
    <b-row class="m-4">
      <b-col>
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search" />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>

    <b-table
      v-cloak
      responsive
      :fields="fields"
      :items="attendanceTable"
      :striped="true"
      :bordered="true"
      :hover="true"
      stacked="md"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    ></b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="attendanceTable.length || 0"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
      <b-col>
        <download-button
          :export="attendanceTable"
          :file="file"
        ></download-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import DownloadButton from '../components/DownloadButton';

export default {
  name: 'DataStudent',
  components: {
    DownloadButton,
  },
  data() {
    return {
      file: 'student-attendance-summary',
      fields: [
        { key: 'country', label: 'Country', sortable: true },
        { key: 'region', label: 'Region', sortable: true },
        { key: 'district', label: 'District', sortable: true },
        { key: 'year', label: 'Year', sortable: true },
        { key: 'month', label: 'Month', sortable: true },
        { key: 'avg_total', label: 'Average Total Days', sortable: true },
        { key: 'avg_present', label: 'Average Days Present', sortable: true },
      ],
      currentPage: 0,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
    };
  },
  methods: {
    ...mapActions({
      GET_ATT_TABLE: 'dashboards/GET_STUDENT_ATTENDANCE_TABLE',
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    stopClick(row) {},
  },
  computed: {
    attendanceTable() {
      return this.$store.state.dashboards.studentAttendanceTable;
    },
  },
  mounted() {
    this.GET_ATT_TABLE();
  },
};
</script>
